export const permissionLevels = {
  noPermission: 0,
  viewOnly: 1,
  viewAndEdit: 2,
  viewAndCreate: 3,
  fullPermission: 4,
};

export const modules = {
  start: {
    path: '/',
    title: '',
  },
  login: {
    path: '/login',
    title: 'Login',
  },
  home: {
    id: 1,
    path: '/app/home',
    title: 'Dashboard',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [
      'card-waiting-picking',
      'card-waiting-packing',
      'card-waiting-shipment',
      'card-waiting-markeplaces',
      'chart-expedition-hour',
      'chart-picking-user',
      'chart-packing-user',
      'type-of-inventory-to-show-at-dashboard',
    ],
  },
  picking: {
    id: 2,
    path: '/app/expedicao/separacao',
    title: 'Separar',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [
      'profile-picking',
      'profile-allow-adding-separation-box',
      'profile-allow-remove-separation-box',
      'profie-picking-box-confirmation',
    ],
  },
  picking_box: {
    id: 2,
    path: /^\/app\/expedicao\/separacao_caixa\/\d+$/gm,
    regex: true,
    title: 'Separação Caixa',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [
      'profile-picking',
      'profile-allow-adding-separation-box',
      'profile-allow-remove-separation-box',
      'profie-picking-box-confirmation',
    ],
  },
  picking_proccess: {
    id: 2,
    path: /^\/app\/expedicao\/separacao_operacao\/\d+$/gm,
    regex: true,
    title: 'Separação Caixa',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [
      'profile-picking',
      'profile-allow-adding-separation-box',
      'profile-allow-remove-separation-box',
      'profie-picking-box-confirmation',
      'profile-allow-picking-mult-quantity',
      'type-of-inventory-when-abort-picking',
    ],
  },
  packingBox: {
    id: 3,
    path: '/app/expedicao/conferencia',
    title: 'Conferir para expedição',
    level: [permissionLevels.viewOnly, permissionLevels.fullPermission],
    params: [],
  },
  pickingBox: {
    id: 4,
    path: '/app/cadastro/caixa_separacao',
    title: 'Caixa de separação',
    level: [
      permissionLevels.noPermission,
      permissionLevels.viewOnly,
      permissionLevels.viewAndCreate,
      permissionLevels.fullPermission,
    ],
    params: ['print-separation-box'],
  },
  packaging: {
    id: 5,
    path: '/app/cadastro/embalagens',
    title: 'Embalagens',
    level: [],
    params: [],
  },
  stockAddress: {
    id: 6,
    path: /^\/app\/cadastro\/armazens\/\d+\/enderecos$/gm,
    regex: true,
    href: '/app/cadastro/armazens/0/enderecos',
    title: 'Endereços de estoque',
    level: [],
    params: ['allow-user-to-create-addresses'],
  },
  productsListing: {
    id: 7,
    path: '/app/estoque/listagem/produtos',
    title: 'Produtos',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['button-inventory-products', 'button-inventory-variation', 'button-remove-address-mapped'],
  },
  manageProducts: {
    id: 7,
    path: '/app/estoque/listagem/produtos',
    title: 'Gerenciar produtos',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['button-inventory-products', 'button-inventory-variation', 'button-remove-address-mapped'],
  },
  quickSearch: {
    id: 8,
    path: '/app/estoque/pesquisa/rapida',
    title: 'Pesquisa rápida',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['button-shortcut-allocation'],
  },
  stockMapping: {
    id: 9,
    path: '/app/estoque/mapeamento/produtos',
    title: 'Mapeamento',
    level: [],
    params: [],
  },
  stockAllocation: {
    id: 10,
    path: '/app/estoque/alocacao/produtos',
    title: 'Alocar',
    level: [],
    params: ['button-allocate-quantity'],
  },
  stockAllocationCallback: {
    id: 10,
    path: /^\/app\/estoque\/alocacao\/produtos\/\w+\/\d+$/gm,
    regex: true,
    title: 'Alocar',
    level: [],
    params: ['button-allocate-quantity'],
  },
  inventoryMovement: {
    id: 11,
    path: '/app/estoque/movimentacao/produtos',
    title: 'Movimentar',
    level: [],
    params: [],
  },
  stockTransfer: {
    id: 12,
    path: '/app/estoque/transferencia/produtos',
    title: 'Transferências',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  stockRequestTransfer: {
    id: 12,
    path: '/app/estoque/transferencia/produtos',
    title: 'Solicitações de transferências',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  stockTransferEdit: {
    id: 12,
    path: /^\/app\/estoque\/transferencia\/produtos\/\d+$/gm,
    regex: true,
    title: 'Transferências',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  inventory: {
    id: 15,
    path: '/app/estoque/inventario/lista',
    title: 'Inventários',
    level: [],
    params: [],
  },
  freeInventory: {
    id: 13,
    path: '/app/estoque/inventario/livre',
    title: 'Inventário livre',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  takeInventory: {
    id: 14,
    path: '/app/estoque/inventariar/lista',
    title: 'Inventariar',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  takeInventorying: {
    id: 14,
    path: /^\/app\/estoque\/inventariar\/\d+\/endereco\/\d+$/gm,
    regex: true,
    title: 'Inventariar',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['allow-mult-quantity-when-inventoring'],
  },
  createInventory: {
    id: 15,
    path: '/app/estoque/inventario/lista',
    title: 'Gerenciar inventários',
    level: [
      permissionLevels.noPermission,
      permissionLevels.viewOnly,
      permissionLevels.viewAndCreate,
      permissionLevels.viewAndEdit,
    ],
    params: ['button-approve-item', 'button-reject-item', 'button-delete-item', 'button-inventory-create'],
  },
  editedInventory: {
    id: 15,
    path: /^\/app\/estoque\/inventario\/editar\/\d+$/gm,
    regex: true,
    title: 'Inventários - editar',
    level: [
      permissionLevels.noPermission,
      permissionLevels.viewOnly,
      permissionLevels.viewAndCreate,
      permissionLevels.viewAndEdit,
    ],
    params: ['button-approve-item', 'button-reject-item', 'button-delete-item', 'button-inventory-create'],
  },
  deliveryVolume: {
    id: 16,
    path: '/app/expedicao/relacao_de_volumes',
    title: 'Relação de volumes',
    level: [],
    params: [],
  },
  reportStockDivergence: {
    id: 17,
    path: '/app/relatorios/divergencia_estoque',
    title: 'Divergências de estoque',
    level: [permissionLevels.noPermission, permissionLevels.viewOnly],
    params: ['button-inventory-variation', 'button-remove-address-mapped', 'button-adjust-stock-divergence'],
  },
  reportEmptyAddress: {
    id: 18,
    path: '/app/relatorios/endereco_zerado',
    title: 'Endereços zerados',
    level: [],
    params: [],
  },
  reportCurveA: {
    id: 19,
    path: '/app/relatorios/curva_a',
    title: 'Produtos p/ Curva ~ A',
    level: [],
    params: [],
  },
  userControl: {
    id: 20,
    path: '/app/sistema/usuarios',
    title: 'Usuários',
    level: [
      permissionLevels.noPermission,
      permissionLevels.viewOnly,
      permissionLevels.viewAndCreate,
      permissionLevels.viewAndEdit,
      permissionLevels.fullPermission,
    ],
    params: [],
  },
  editUserControl: {
    id: 20,
    path: /^\/app\/sistema\/usuarios\/cadastro\/\d+$/gm,
    regex: true,
    title: 'Usuários',
    level: [
      permissionLevels.noPermission,
      permissionLevels.viewOnly,
      permissionLevels.viewAndCreate,
      permissionLevels.viewAndEdit,
      permissionLevels.fullPermission,
    ],
    params: [],
  },
  logView: {
    id: 21,
    path: '/app/sistema/visualizar/logs',
    title: 'Visualizar Logs',
    level: [],
    params: [],
  },
  pickingPriority: {
    id: 22,
    path: '/app/sistema/prioridade-separacao',
    title: 'Prioridade de separação',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  takeTransfer: {
    id: 23,
    path: '/app/estoque/transferir',
    title: 'Transferir',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['button-transfer-approve-item', 'button-transfer-remove-item', 'button-transfer-edit-item'],
  },
  takeTransferEdit: {
    id: 23,
    path: /^\/app\/estoque\/transferir\/\d+$/gm,
    regex: true,
    title: 'Transferir',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['button-transfer-approve-item', 'button-transfer-remove-item', 'button-transfer-edit-item'],
  },
  receiving: {
    id: 38,
    path: '/app/estoque/recebimentos',
    title: 'Recebimentos',
    level: [],
    params: ['profile-allow-receiving-mult-quantity'],
  },
  receivingSchedulingConfig: {
    id: 38,
    path: '/app/estoque/recebimentos/configurar_agenda',
    title: 'Configurar disponibilidade',
    level: [],
    params: ['allow-user-to-configure-receiving-schedules'],
  },
  receivingSchedule: {
    id: 38,
    path: '/app/estoque/recebimentos/agenda_recebimento',
    title: 'Agenda',
    level: [],
    params: ['allow-user-to-block-receiving-schedule', 'allow-user-to-configure-receiving-schedules'],
  },
  receivingApproveScheduling: {
    id: 38,
    path: '/app/estoque/recebimentos/aprovar_agendamentos',
    title: 'Solicitações de agendamento',
    level: [],
    params: ['allow-user-to-approve-receiving-schedule'],
  },
  receivingReceive: {
    id: 38,
    path: '/app/estoque/recebimentos/receber/editar/1',
    title: 'Receber',
    level: [],
    params: ['profile-allow-receiving-mult-quantity'],
  },
  receivingConference: {
    id: 38,
    path: '/app/estoque/recebimentos/receber',
    title: 'Gerenciar recebimentos',
    level: [],
    params: [
      'profile-allow-receiving-mult-quantity',
      'allow-user-to-approve-divergent-receive',
      'allow-user-to-reprove-divergent-receive',
      'allow-user-to-noshow-receive',
    ],
  },
  receivingDashboard: {
    id: 38,
    path: '/app/estoque/recebimentos/dashboard',
    title: 'Torre de controle',
    level: [],
    params: [],
  },
  receivingProductsConference: {
    id: 38,
    path: '/app/estoque/recebimentos/receber/editar/1',
    title: 'Conferir recebimento',
    level: [],
    params: [],
  },
  receivingApproveSchedulingRequests: {
    id: 38,
    path: '/app/estoque/recebimentos/aprovar_agendamentos',
    title: 'Solicitações de agendamento',
    level: [],
    params: ['allow-user-to-approve-receiving-schedule'],
  },
  inventoryRequests: {
    id: 37,
    path: '/app/estoque/inventario/solicitacoes',
    title: 'Solicitações de inventário',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  sales: {
    id: 39,
    path: '/app/vendas/pedidos',
    title: 'Gerenciar vendas',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['picking-submenu-button-unassign-user'],
  },
  salesCreate: {
    id: 39,
    path: '/app/vendas/pedidos/cadastro',
    title: 'cadastrar uma nova venda',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['allow-user-to-create-order'],
  },
  salesDetails: {
    id: 39,
    path: '/app/vendas/pedidos/detalhes',
    title: 'Detalhes de vendas',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: ['allow-user-to-edit-order'],
  },
  search: {
    id: 40,
    path: '/app/estoque/pesquisa',
    title: 'Pesquisa',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  userActions: {
    id: 41,
    path: '/app/relatorios/acoes_de_usuarios',
    title: 'Ações de usuários',
    level: [permissionLevels.noPermission, permissionLevels.fullPermission],
    params: [],
  },
  reportReceivingDivergence: {
    id: 42,
    path: '/app/relatorios/divergencia_recebimento',
    title: 'Divergências de recebimentos',
    level: [],
    params: [],
  },
  reSupplies: {
    id: 44,
    path: '/app/estoque/ressuprimento/movimentacao_por_necessidade',
    title: 'Ressuprimentos',
    level: [permissionLevels.viewOnly, permissionLevels.fullPermission],
    params: ['hide-products-super-stock-packing'],
  },
  movementByNecessity: {
    id: 44,
    path: '/app/estoque/ressuprimento/movimentacao_por_necessidade',
    title: 'Movimentação por necessidade',
    level: [permissionLevels.viewOnly, permissionLevels.fullPermission],
    params: ['hide-products-super-stock-packing'],
  },
  storage: {
    id: 45,
    path: '/app/cadastro/armazens',
    title: 'Armazéns',
    level: [],
    params: ['allow-user-to-create-storages'],
  },
  storageEdit: {
    id: 45,
    path: /^\/app\/cadastro\/armazens\/editar\/\d+$/gm,
    regex: true,
    title: 'Armazéns - editar',
    level: [],
    params: ['allow-user-to-create-storages'],
  },
};
